import React, { memo, useCallback } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import {
  IconClose03,
  IconArrowDown02,
  IconClose02,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** mode */
  mode?: 'word' | 'filter' | 'modalFilter' | undefined;
  /** type */
  type?: 'sale' | undefined | string;
  /** text */
  text?: string;
  /** active */
  active?: boolean;
  /** className */
  className?: string;
  /** onClick */
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  /** onClose */
  onClose?: () => void | undefined;
}

const DynmBtn = ({
  mode = 'word',
  type,
  text = '',
  active,
  className,
  onClick,
  onClose,
}: IProps) => {
  const cName = classNameBind([
    'dynm-btn item',
    mode || '',
    type || '',
    active ? 'active' : '',
    onClose ? 'type-close' : '',
    className || '',
  ]);

  // ITEM RENDERER : getTextRender
  const getTextRender = useCallback(
    () => (
      <Text ellipsis={1} maxWidth={175}>
        {text}
      </Text>
    ),
    [text]
  );

  const getButtonRender = useCallback(
    () => (
      <>
        {onClick && (
          <Button onClick={onClick}>
            {getTextRender()}
            {type !== 'saleTag' && mode === 'filter' && <IconArrowDown02 />}
          </Button>
        )}
        {onClose && (
          <Button onClick={onClose} className="btn-close">
            {mode === 'word' && <IconClose03 />}
            {mode === 'filter' && (
              <>
                {getTextRender()}
                <IconClose02 />
              </>
            )}
          </Button>
        )}
      </>
    ),
    [getTextRender, mode, onClick, onClose, type]
  );

  return <S.DynmBtn className={cName}>{getButtonRender()}</S.DynmBtn>;
};

export default memo(DynmBtn);
